import {useTranslation} from "@Translation/hooks/useTranslation";
import {multiModalTranslationKey} from "@SearchResults/features/staticContent/constants/translationKeys";
import TitleAndContent from "@SearchResults/features/staticContent/components/TitleAndContent";

interface HowCanIBookContentProps {
    departure: string,
    destination: string,
}

function HowCanIBookContent({departure, destination}: HowCanIBookContentProps) {
    const title = useTranslation(
        `${multiModalTranslationKey}.how_can_i_book.title`,
        {departure, destination}
    )

    const description1 = useTranslation(
        `${multiModalTranslationKey}.how_can_i_book.desc1`,
        {departure, destination}
    )

    return (
        <TitleAndContent
            title={title}
            content={description1}
        />
    )
}

export default HowCanIBookContent